import { render, staticRenderFns } from "./DiscussNoteBubble.vue?vue&type=template&id=f35bc288&"
import script from "./DiscussNoteBubble.vue?vue&type=script&lang=js&"
export * from "./DiscussNoteBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports